import Pagination from '@components/tailwind/Pagination';
import usePaginatedProducts from '../hooks/usePaginatedProducts';
import NoResultsFound from './NoResultsFound';
import ProductCard from './product-card';
import ProductsListActions from './ProductsListActions';
import SelectedFilters from './SelectedFilters';
import GridElement from '@components/tailwind/GridElement';
import { useSelector } from 'react-redux';
import { AppState } from '@/store';

const ProductsList = ({ rel }) => {
  const itemGridElements = useSelector((state: AppState) => state.partner?.pageDesign?.itemGridElements);
  const { products, page, onPageChangeHandler, productsCount, shouldShowPagination, pages } =
    usePaginatedProducts();

  return (
    <div className='tw-mb-4 tw-mt-10'>
      <ProductsListActions productsCount={productsCount} />
      <SelectedFilters />
      {!productsCount && <NoResultsFound />}
      {productsCount > 0 && (
        <div className='tw-grid tw-grid-cols-1 tw-gap-4 sm:tw-grid-cols-2 xl:tw-grid-cols-3'>
          {products?.length > 0 &&
            products.map((product, i) =>
              (itemGridElements || [])
                .filter((e) => e.itemGridPos === i)
                .map((element) => (
                  <GridElement
                    key={element.id}
                    productsCount={productsCount}
                    element={element}
                    {...{ rel }}
                  />
                ))
                .concat(<ProductCard key={'product.' + i} product={product} {...{ rel }} />)
            )}

          {(itemGridElements || [])
            .filter((e) => !e.itemGridPos || e.itemGridPos >= productsCount)
            .map((element) => (
              <GridElement key={element.id} productsCount={productsCount} element={element} {...{ rel }} />
            ))}
        </div>
      )}
      {shouldShowPagination && <Pagination page={page} pages={pages} onPageChange={onPageChangeHandler} />}
    </div>
  );
};

export default ProductsList;
